import getCustomerLocation from "./get-customer-location.js";

const hideButtonsBasedOnCountry = async () => {

  try {
    let country = await getCustomerLocation();

    if (!country) return;

    const clickAndCollectButton = document.querySelector(
      ".product-single__store-availability-container"
    );

    const shopPayTermsDiv = document.querySelector(".shop-pay-terms");

    if (country.handle !== "DE" && clickAndCollectButton) {
      clickAndCollectButton.style.display = "none";
    }

    if (country.handle !== "US" && shopPayTermsDiv) {
      shopPayTermsDiv.style.display = "none";
    }
  } catch (error) {
    console.error("Error in hideButtonsBasedOnCountry:", error);
  }
};

// Run after all content, images, scripts, and stylesheets have finished loading
window.addEventListener("load", hideButtonsBasedOnCountry);
